import React from 'react';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SlideshowImageItemUi_ViewerVersion1 = ({ alt, asset, contentItem })=> (
  <img
    alt={alt}
    style={{
      margin: '0 auto',
      maxWidth: '100%',
      maxHeight: '100%'
    }}
    src={(contentItem && ((contentItem.tile_inner_zf_image && contentItem.tile_inner_zf_image.isUncompressed) || contentItem.tile_display_type === 'uploaded') && asset.originalImage) ? asset.originalImage : asset.displayImage}
  />
);

const SlideshowImageItemUi_ViewerVersion2 = ({ idx, alt, asset, contentItem })=> (
  <img
    src={(contentItem && ((contentItem.tile_inner_zf_image && contentItem.tile_inner_zf_image.isUncompressed) || contentItem.tile_display_type === 'uploaded') && asset.originalImage) ? asset.originalImage : asset.displayImage}
    alt={alt || `Slide ${idx + 1} image`}
  />
);

const SlideshowImageItem = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SlideshowImageItemUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SlideshowImageItemUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SlideshowImageItem;
